import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import EditCommerceCategoriesContext from 'contexts/EditCommerceCategoriesContext';
import AppContext from 'contexts/AppContext';
import CommerceCategory from 'types/models/CommerceCategory';
import ListCommerceCategoriesPage from 'pages/private/admin/ListCommerceCategoriesPage';
import CreateCommerceCategoriesPage from 'pages/private/admin/CreateCommerceCategoriesPage';
import EditCommerceCategoriesPage from 'pages/private/admin/EditCommerceCategoriesPage';
import { hasPermission } from 'utils/hasPermission';
import PermissionCode from 'types/enums/PermissionCode';

export default ({ match }: RouteComponentProps): JSX.Element => {
  const { permissions } = React.useContext(AppContext);
  const [selectedCommerceCategory, setSelectedCommerceCategory] = React.useState<CommerceCategory | null>(null);

  if (!hasPermission(permissions, PermissionCode.CommerceCategoriesView)) {
    return <Redirect to="/private/welcome" />;
  }

  return (
    <EditCommerceCategoriesContext.Provider value={{ selectedCommerceCategory, setSelectedCommerceCategory }}>
      <Switch>
        <Route exact={true} path={`${match.url}`} component={ListCommerceCategoriesPage} />
        <Route path={`${match.url}/create`} component={CreateCommerceCategoriesPage} />
        <Route path={`${match.url}/edit`} component={EditCommerceCategoriesPage} />
        <Redirect to="/private/welcome" />
      </Switch>
    </EditCommerceCategoriesContext.Provider>
  );
};
